import api from './api'

// Types
export interface PracticeProduct {
  id: string
  clinic_id: string
  name: string
  description: string | null
  category: 'visit' | 'procedure' | 'product' | 'lab' | 'other'
  price_cents: number
  default_cpt_code: string | null
  default_icd_codes: string[] | null
  is_taxable: boolean
  is_active: boolean
  sort_order: number
  metadata: Record<string, unknown>
  created_by: string | null
  created_at: string
  updated_at: string
}

export interface PracticeProductListResponse {
  products: PracticeProduct[]
  total: number
  page: number
  limit: number
}

export interface CreatePracticeProductInput {
  name: string
  priceCents: number
  category?: string
  cptCode?: string
  icdCodes?: string[]
  description?: string
  isTaxable?: boolean
  sortOrder?: number
}

export interface UpdatePracticeProductInput {
  name?: string
  description?: string
  category?: string
  price_cents?: number
  default_cpt_code?: string | null
  default_icd_codes?: string[] | null
  is_taxable?: boolean
  sort_order?: number
}

export interface PracticeProductListParams {
  category?: string
  activeOnly?: boolean
  search?: string
  page?: number
  limit?: number
}

export const practiceProductsService = {
  async list(clinicId: string, params: PracticeProductListParams = {}): Promise<PracticeProductListResponse> {
    const queryParams = new URLSearchParams()
    if (params.category) queryParams.set('category', params.category)
    if (params.activeOnly !== undefined) queryParams.set('activeOnly', String(params.activeOnly))
    if (params.search) queryParams.set('search', params.search)
    if (params.page) queryParams.set('page', String(params.page))
    if (params.limit) queryParams.set('limit', String(params.limit))

    const response = await api.get(`/emr/${clinicId}/practice-products?${queryParams.toString()}`)
    return response.data?.data
  },

  async getById(clinicId: string, productId: string): Promise<PracticeProduct> {
    const response = await api.get(`/emr/${clinicId}/practice-products/${productId}`)
    return response.data?.data
  },

  async create(clinicId: string, input: CreatePracticeProductInput): Promise<PracticeProduct> {
    const response = await api.post(`/emr/${clinicId}/practice-products`, input)
    return response.data?.data
  },

  async update(clinicId: string, productId: string, input: UpdatePracticeProductInput): Promise<PracticeProduct> {
    const response = await api.put(`/emr/${clinicId}/practice-products/${productId}`, input)
    return response.data?.data
  },

  async delete(clinicId: string, productId: string): Promise<void> {
    await api.delete(`/emr/${clinicId}/practice-products/${productId}`)
  },

  async linkToAppointmentType(clinicId: string, productId: string, appointmentTypeId: string): Promise<void> {
    await api.post(`/emr/${clinicId}/practice-products/${productId}/link-appointment-type/${appointmentTypeId}`)
  },
}
